import Banner from "./components/Banner";
import Introduction from "./components/Introduction";

const Home = () => {
  return (
    <>
      <Banner />
      <Introduction />
    </>
  );
};

export default Home;
